import { useState, useEffect } from 'react';

export const useIsPrint = (): boolean => {
  const [isPrint, setIsPrint] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR safety

    const mediaQuery = window.matchMedia('print');
    setIsPrint(mediaQuery.matches);

    const handleChange = (e: MediaQueryListEvent) => setIsPrint(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isPrint;
};
